import momentJalaaliGenerateConfig from './momentJalali';
import generatePicker from 'antd/es/date-picker/generatePicker';
import "moment/locale/fa";

const DatePicker = generatePicker(momentJalaaliGenerateConfig);

export default DatePicker;